import {
    RequestKeys,
} from 'app/hooks/useRequest'

import ChangeHistory from 'app/shared-components/ChangeHistory'

import config from 'app/requests/Gateway.requests'

const GatewayChangeHistory = ({
    id,
}: { id: number }) => {
    return (
        <ChangeHistory
            id={id}
            requestKey={RequestKeys.getGatewayModifications}
            config={config.modifications}
            configName="GatewayChangeHistoryTable"
            name="GatewayChangeHistory"
            labelPrefixForChangedColumn={['Gateway']}
        />
    )
}

export default GatewayChangeHistory
